export default "__VITE_ASSET__t0rnxkSG__"